import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";

import MaterialsIcons from "../../Icons/MaterialsIcons";
import {PAYMENT_STEPS} from "./jobPaymentReducer";
import {setJobPaymentStep} from "./jobPaymentActions";


const JobPaymentPopupHeader = (props) => {

  const {closePopup, jobTotal, setJobPaymentStep} = props;

  const newPaymentClick = () => {
    setJobPaymentStep(PAYMENT_STEPS.billing);
  }

  const viewTransactionsClick = () => {
    setJobPaymentStep(PAYMENT_STEPS.transactions);
  }

  return (
    <div className={"job-payment__header job-payment__container flex flex--center flex--between relative"}>
      <div className="job-payment__header-total flex flex--center flex-item flex--between pr-1">
        <div className="job-payment__header-item margin-r16">
          <div className="job-payment__header-total-title">
            <FormattedMessage id="paymentPopup.total"/>
          </div>
          <div className="job-payment__header-total-amount">${jobTotal.toFixed(2)}</div>
        </div>
        <div className="job-payment__header-item">
          <div className="job-payment__header-total-title">
            <FormattedMessage id="paymentPopup.balanceDue"/>
          </div>
          <div className="job-payment__header-total-amount">${jobTotal.toFixed(2)}</div>
        </div>
      </div>
      <div className="job-payment__header-invoice nowrap">
        <button className="ui-button5 ui-button5--13 ui-button5--flex ui-button5--flex-icon-left
        ui-button5--flex-icon-left--small ui-button5--gray-border margin-r8"
                onClick={newPaymentClick}>
          <span className="ui-button5__material-icon">{MaterialsIcons.PaymentIcon}</span>
          <FormattedMessage id="paymentPopup.newPayment"/>
        </button>
        <button className="ui-button5 ui-button5--13 ui-button5--flex ui-button5--flex-icon-left
        ui-button5--flex-icon-left--small ui-button5--gray-border"
                onClick={viewTransactionsClick}>
          <span className="ui-button5__material-icon">{MaterialsIcons.ListIcon}</span>
          {/*<FormattedMessage id="paymentPopup.invoiceButton"/>*/}
          View Transactions
        </button>
      </div>
      <button className="ui-popup-header__close ui-popup-header__close--small assign-filters__filter-close"
              onClick={closePopup}/>
    </div>
  )
};

JobPaymentPopupHeader.propTypes = {
  closePopup: PropTypes.func.isRequired,
}

const mapStateToProps = (store) => {
  const {jobTotal} = store.jobPaymentState;
  return {
    jobTotal,
  };
};

const mapDispatchToProps = {
  setJobPaymentStep,
};

export default (
  connect(mapStateToProps, mapDispatchToProps)(JobPaymentPopupHeader)
)
